import React, { useEffect, useState } from "react"
import styles from './PopupGuidance.module.css'
import Button from "../../material/button/Button"
import img1 from '../../../asset/image/guid1.svg'

function PopupGuidance({ show, onClose }) {

    const [pageIndex, setPageIndex] = useState(0)

    const backButton = () => {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1)
        }
    }
    const nextButton = () => {
        if (pageIndex < 2) {
            setPageIndex(pageIndex + 1)
        }
    }

    useEffect(() => {
        setPageIndex(0)
    }, [show])


    return (
        <>
            {show ?
                <div className={styles.overlay}>
                    <div className={styles.modalContainer}>
                        <div className={styles.closeButtonContainer}>
                            <img onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default}></img>
                        </div>
                        <div className={styles.headerContainer}>
                            <div className={styles.text}>ติดตั้งระบบยืนยันตัวตนด้วยการเสียบบัตร</div>
                        </div>
                        <div className={styles.slideContainer}>
                            <div className={styles.slide}
                                style={{
                                    marginLeft: '-' + pageIndex * 100 + '%'
                                }}
                            >
                                <div className={styles.slideSub}>
                                    <img src={img1} />
                                </div>
                                <div className={styles.slideSub}>
                                    <img src="/images/guid2.svg" />
                                </div>
                                <div className={styles.slideSub}>
                                    <img src="/images/guid3.svg" />
                                </div>
                            </div>
                        </div>

                        <div className={styles.buttonContainer}>
                            {pageIndex !== 0 ? <Button onClick={backButton} style={{ width: 130, background: "#fff" }}>ย้อนกลับ</Button> : null}
                            {pageIndex !== 2 ? <Button onClick={nextButton} style={{ width: 130 }}>ถัดไป</Button> : null}
                        </div>
                    </div>
                </div>
                : null
            }
        </>
    )
}
export default PopupGuidance